import styled, { css } from 'styled-components';

import { breakpoints, theme } from '@notino/react-styleguide';

import { Wrapper, Currency } from '@components/PriceLabel/components';
export const Container = styled.div<{
  newDesign: boolean;
}>`
  margin-top: 0;

  ${({ newDesign }) =>
    newDesign
      ? css`
          @media (min-width: ${breakpoints.lg}) {
            margin-top: 1rem;
          }
        `
      : css`
          @media (min-width: ${breakpoints.md}) {
            margin-top: 1.25rem;
          }
        `}
`;

export const FlexWrapper = styled.div<{ newDesign: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  ${({ newDesign }) =>
    newDesign
      ? css`
          margin-top: 1.5rem;
          height: 2rem;
        `
      : css`
          min-height: 2.1875rem;

          @media (min-width: ${breakpoints.sm}) {
            min-height: 3.25rem;
          }
        `}
`;

export const LineWrapper = styled.div<{ newDesign: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${({ newDesign }) =>
    newDesign
      ? css`
          margin: 0.75rem 0;
          @media (min-width: ${breakpoints.lg}) {
            margin-top: 0.5rem;
          }
        `
      : css`
          margin-top: 0.6rem;
          margin-bottom: 0.2rem;
        `}
`;

export const Line = styled.hr<{ dashedLine: boolean }>`
  flex: 1;
  ${({ dashedLine }) =>
    dashedLine
      ? `border-top: 1px dashed ${theme.color.border.divider};`
      : `border-top: 1px solid ${theme.color.border.default};`};
  height: 0.0625rem;
  margin: 0;
  border-bottom: none;
`;

export const Name = styled.div<{
  newDesign: boolean;
  isSmall: boolean;
}>`
  padding: 0 0.5rem 0.05rem 0;
  ${({ newDesign, isSmall }) =>
    newDesign
      ? css`
          ${isSmall
            ? theme.typography.labelRegular400
            : theme.typography.labelLarge400}
        `
      : css`
          font-weight: 400;
          font-size: 1.25rem;

          @media (min-width: ${breakpoints.sm}) {
            font-size: 1.3rem;
            padding: 0 0.5rem 0.2rem 0;
          }
          @media (min-width: ${breakpoints.md}) {
            font-size: 1.3rem;
            padding: 0 0.5rem 0.3rem 0;
          }
        `}
`;

export const PriceWrapper = styled(Wrapper)`
  ${theme.typography.titleDisplay}
`;

export const SmallerPriceWrapper = styled(Wrapper)`
  ${theme.typography.labelLarge}
`;

export const CurrencyWrapper = styled(Currency)`
  ${theme.typography.titleLarge}
`;

export const SmallerCurrencyWrapper = styled(Currency)`
  ${theme.typography.labelLarge}
`;

export const DualPriceWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

export const DualPrice = styled.div<{ newDesign: boolean; isSmall: boolean }>`
  font-size: 1.55rem;
  font-weight: 700;
  ${({ newDesign, isSmall }) =>
    newDesign
      ? isSmall
        ? theme.typography.labelLarge
        : theme.typography.titleLarge
      : ''}
`;

export const DualPriceSplitter = styled.div<{
  newDesign: boolean;
  isSmall: boolean;
}>`
  padding: 0 0.3rem;
  font-size: 1.55rem;
  font-weight: 700;
  ${({ newDesign, isSmall }) =>
    newDesign
      ? isSmall
        ? theme.typography.labelLarge
        : theme.typography.titleLarge
      : ''}
`;
